export enum CarouselItemVariants {
  BEFORE_AFTER = 'before_after',
  DEFAULT = 'default',
}

export enum CarouselVariants {
  ALTERNATE = 'alternate',
  DEFAULT = 'default',
}
